import { registerArtifact } from './artifact-registry';
import { FlowByPhaseArtifact } from './flow-by-phase/flow-by-phase-artifact';
import { FreeformChartArtifact } from './freeform-chart/freeform-chart-artifact';
import { MeasureComparisonArtifact } from './measure-comparison/measure-comparison-artifact';
import { MeasuresOverTimeArtifact } from './measures-over-time/measures-over-time-artifact';
import { ProcessMapArtifact } from './process-map-artifact';
import { WorkPaceArtifact } from './work-pace/work-pace-artifact';

registerArtifact('flow_by_phase_chart', {
  component: FlowByPhaseArtifact,
  label: 'Flow by Phase',
});

registerArtifact('freeform_chart', {
  component: FreeformChartArtifact,
  label: 'Chart',
});

registerArtifact('measure_comparison_chart', {
  component: MeasureComparisonArtifact,
  label: 'Measure Comparison',
});

registerArtifact('measures_over_time_chart', {
  component: MeasuresOverTimeArtifact,
  label: 'Measures Over Time',
});

registerArtifact('process_map_chart', {
  component: ProcessMapArtifact,
  label: 'Process Map',
});

registerArtifact('work_pace_chart', {
  component: WorkPaceArtifact,
  label: 'Work Pace',
});
